import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import format from 'date-fns/format';

import ArrowIcon from '@mui/icons-material/ArrowRightAlt';
import Box from '@mui/material/Box';

import { FlightInfoFullSegment_segment$key } from '__generated__/FlightInfoFullSegment_segment.graphql';

type Props = {
  segment: FlightInfoFullSegment_segment$key;
};

const segmentStyles = {
  fontWeight: 500,
  mb: 1,
};

const FlightInfoFullSegment: FC<Props> = ({ segment }) => {
  const {
    departAirportCode,
    departDatetime,
    arrivalAirportCode,
    arrivalDatetime,
  } = useFragment(
    graphql`
      fragment FlightInfoFullSegment_segment on FlightSegment {
        departAirportCode
        departDatetime
        arrivalAirportCode
        arrivalDatetime
      }
    `,
    segment
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <Box sx={segmentStyles}>
        {format(new Date(departDatetime), 'HH:mm')} {departAirportCode}
      </Box>

      <ArrowIcon sx={{ marginTop: '-3px' }} />

      <Box sx={segmentStyles}>
        {format(new Date(arrivalDatetime), 'HH:mm')} {arrivalAirportCode}
      </Box>
    </Box>
  );
};

export default FlightInfoFullSegment;
